import { AttributesMixin, define, Model, type } from "@type-r/models";
import { DateFilter, formatDateFilter } from "../../components/search-bar/filters/date-filter";
import { DropdownFilter } from "../../components/search-bar/filters/dropdown-filter";
import { TextFilter } from "../../components/search-bar/filters/text-filter";
import { PagingSortingBaseRequest } from "../../import-templates/models/get-filtered-import-templates-request";

const defaultSort = {
    attr: "createdOn",
    asc: false
};
export interface GetFilteredImportJobsRequest extends PagingSortingBaseRequest {
    filterAll: string;
    statusId: number;
    jobId: string;
    assetTypeId: number;
    originalFileName: string;
    connectionId: number;
    connectionName: string;
    processedOn: string;
    sortBy: string;
}

export const SortingTemplate = {
    createdOn: 'Created On',
    updatedOn: 'Updated On'
}

export interface ImortJobsFilters extends AttributesMixin<typeof ImortJobsFilters> { }

@define
export class ImortJobsFilters extends Model {
    static attributes = {
        filterAll: '',
        assetType: DropdownFilter,
        status: DropdownFilter,
        jobId: type(TextFilter),
        fileName: type(TextFilter),
        connectionId: type(TextFilter),
        connectionName: type(TextFilter),
        processedOn: type(DateFilter),
        sortBy: type(defaultSort)
    }
    reset() {
        this.filterAll = '';
        this.assetType.$.selected.set(0);
        this.status.$.selected.set(0);
        this.jobId.$.value.set('');
        this.fileName.$.value.set('');
        this.connectionId.$.value.set('');
        this.connectionName.$.value.set('');
        this.processedOn.$.date.set(null);
    }

    mapToQuery(skip: number = 0, take: number = 100) {
        return {
            quickSearch: this.filterAll,
            assetTypeId: this.assetType.selected,
            statusId: this.status.selected,
            jobId: this.jobId.value,
            originalFileName: this.fileName.value,
            connectionId: +this.connectionId.value,
            connectionName: this.connectionName.value,
            processedOn: this.processedOn.date ? formatDateFilter(this.processedOn.date) : '',
            sortBy: this.sortBy.attr,
            asc: this.sortBy.asc,
            skip,
            take
        } as GetFilteredImportJobsRequest;
    }

    setJobId(id) {
        this.jobId.$.value.set(id);
    }
}
